﻿export function parseAutocompleteList(list, data) {
  let li = document.createElement('li')
  li.className = 'text-right';
  let anchor = document.createElement('a');
  anchor.className = 'btn btn-outline-primary inline-block';
  anchor.href = `/shop?q=${data.query}`;
  anchor.innerText = 'Vedi Tutti'
  li.appendChild(anchor);
  list.appendChild(li);
}

export function parseAutocompleteItem(item, data) {
  item.innerText = '';
  let article = data.value;
  let imageUrls = Object.values(article.imageUrls);
  if (imageUrls.length > 0) {
	let img = document.createElement('img');
	img.className = 'element-image';
	img.src = imageUrls[0][0];
	item.appendChild(img);
  }

  let name = document.createElement('h5');
  name.className = 'element-name';
  name.innerHTML = article.name;
  item.appendChild(name);

  let price = document.createElement('h6');
  price.className = 'element-price';
  if (article.variantPrices.length > 0) {
	price.innerHTML = `€ ${article.variantPrices.filter(p => p.priceType.id === 'web')[0].sellPrice.toFixed(2)}`;
  } else {
	price.innerHTML = `€ ${article.prices.filter(p => p.priceType.id === 'web')[0].sellPrice.toFixed(2)}`;
  }
  item.appendChild(price);
}